import pulse from '@finn-no/pulse-sdk';
import type { Vertical } from '@/data/verticals';

export const trackDestinationPageView = (vertical: Vertical) => {
    // TR_pv08 (see tracking section in README.md)
    pulse.trackPageView({
        object: {
            url: window.location.href,
            type: 'Page',
            pageType: 'travel_destination',
        },
        vertical: {
            name: 'travel',
            subVertical: getPulseVertical(vertical),
        },
    });
};

const getPulseVertical = (vertical: Vertical): string => {
    switch (vertical) {
        case 'flight':
            return 'flight';
        case 'hotel':
            return 'hotel';
        case 'carrental':
            return 'car_rental';
        case 'prepackage':
            return 'prepackage';
        case 'fhh':
            return 'holiday_rental';
    }
};
